import React, { useContext } from "react";
import { CombinedContext } from "../../../context/combinedContext";
import "./contactSupport.css";
import translations from "../../../translations/translations";

const ContactSupport = () => {
	const { language } = useContext(CombinedContext);

	return (
		<div className="contact-page">
			<div className="contact-container">
				<h1 className="contact-title">{translations[language].contact.title}</h1>

				{/* General Support */}
				<section className="contact-section">
					<h2>{translations[language].contact.support.title}</h2>
					<p>{translations[language].contact.support.text}</p>
				</section>

				{/* Email */}
				<section className="contact-section">
					<h2>{translations[language].contact.email.title}</h2>
					<p>
						{translations[language].contact.email.text}{" "}
						<a href="mailto:soporte@reservasinfila.com" className="contact-email">
							soporte@reservasinfila.com
						</a>
					</p>
				</section>

				{/* Response Time */}
				<section className="contact-section">
					<h2>{translations[language].contact.response.title}</h2>
					<p>{translations[language].contact.response.text}</p>
				</section>
			</div>
		</div>
	);
};

export default ContactSupport;
